var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-overlay",
    {
      staticStyle: {
        position: "fixed !important",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
      },
      attrs: {
        value: _vm.internalShow,
        "z-index": _vm.zIndex,
        attach: "body",
        absolute: "",
      },
    },
    [
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("v-progress-circular", {
            attrs: {
              size: _vm.size,
              width: _vm.width,
              color: "pink lighten-2",
              indeterminate: "",
            },
          }),
          _vm.message
            ? _c(
                "div",
                { staticClass: "mt-3 white--text font-weight-medium" },
                [_vm._v(" " + _vm._s(_vm.message) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }